/* 模态框显示
// modelState
// */

const state = {
  modelState: {
    //个人中心
    personalState: false,
    //消息中心
    messageState: false,
    //强制修改初始化密码
    resetInitPwd: false,
    //退出登录
    modalQuit:false
  },
}

const getters = {
  modelState: state => {
    return state.modelState
  },
}

const mutations = {
  SetPersonalState(state, data) {
    return state.modelState.personalState = data
  },
  SetMessageState(state,data){
    return state.modelState.messageState = data
  },
  SetResetInitPwd(state,data){
    return state.modelState.resetInitPwd = data
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modelState/personal.js